<template>
    <inertia-link
        class="logo"
        href="/"
    >
        <figure class="object-contain">
            <!-- @todo: Aanpassen zodra alle logo's in SVG beschikbaar. -->
            <img
                :src="require(`~/assets/images/logos/classmate-logo.svg`).default"
                alt="logo"
                v-if="this.$store.state.foundation === 'classmate'">
            <img
                :src="require(`~/assets/images/logos/sbn-logo.svg`).default"
                alt="logo"
                v-else-if="this.$store.state.foundation === 'sbn'">
            <img
                :src="require(`~/assets/images/logos/sho-logo.svg`).default"
                alt="logo"
                v-else>

        </figure>
    </inertia-link>

</template>

<script>
    export default {
        name: 'Logo'
    }
</script>

<style lang="scss" scoped>
.logo {
    height: 40px;

    figure {
        height: 100%;

        img {
            width: auto;
        }
    }
}
</style>
